import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, doc, setDoc, updateDoc } from "firebase/firestore";

function editarTotal_facturas_manifiesto(total_facturas_manifiesto, Manifiesto_Seleccionado) {
  var Total_facturas_manifiesto = {total_facturas_manifiesto};
  const db = getFirestore(firebaseApp);
  const collectionRef = collection(db,"/Manifiestos/Manifiestos/Manifiestos/".replace(/ /g, ""));
  const docRef = doc(collectionRef, (Manifiesto_Seleccionado.fecha_actual3).toString());
  updateDoc(docRef, Total_facturas_manifiesto);
}

export default editarTotal_facturas_manifiesto;
